<template>
  <div class="band">
    <el-row :gutter="24">
      <el-col :span="2" style="padding-right: 0 !important;">
        <div class="Piyasa">
          <b>$</b>
          <span v-if="Liste">{{ Liste.Dolar.Alis }}</span>
        </div>
      </el-col>
      <el-col :span="2" style="padding-right: 0 !important;">
        <div class="Piyasa">
          <b>€</b>
          <span v-if="Liste">{{ Liste.Euro.Alis }}</span>
        </div>
      </el-col>
      <el-col :span="15">
        <div class="haber">
          <a href="https://www.aa.com.tr/" target="_blank"> <img
            src="https://cdnassets.aa.com.tr/assets/images/aalogomin.png"></a>
          <el-carousel height="20px" direction="vertical" :autoplay="true" :interval="4000">
            <el-carousel-item v-for="(h,index) in Haber" :key="index">
              <a :href="h.link" target="_blank"><small class="tarih"><i class="el-icon-time"></i> {{
                  h.pubDate
                }}</small> <b>{{ h.title }}</b></a>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
      <el-col :span="3" style="padding-left: 0 !important;">
        <div class="HavaDurumu">
          <img :src="'http://openweathermap.org/img/wn/'+HavaDetay.weather[0].icon+'.png'">
          <span class="description">{{ HavaDetay.weather[0].description }}</span>
          <span class="temp">{{ HavaDetay.main.temp }}°</span>
        </div>
      </el-col>
      <el-col :span="2" style="padding-left: 0 !important;">
        <DigitalClock class="Saat" :blink="true" :displaySeconds="true"></DigitalClock>
      </el-col>
    </el-row>
  </div>
</template>
<script>

import DigitalClock from "vue-digital-clock"


export default {
  components: {DigitalClock},
  data() {
    return {
      geo: null,
      Liste: null,
      Haber: null,
      HavaDetay: null,
    }
  },


  methods: {
    SayfaYukle() {
      this.$store.dispatch("Get", {path: 'panel/band'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Liste = response.Liste;
            this.Haber = response.Haber;
            this.HavaDetay = response.Hava;
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    }
    ,
  },
  created() {
    this.SayfaYukle();
    this.$getLocation()
      .then(coordinates => {
        this.geo = coordinates;
      });
  }
}
</script>

<style>
.band {
  position: relative;
  background-color: #323b44;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 2px;
  box-shadow: inset 0 0 10px 5px #323b44;
}

.band .Piyasa {
  text-align: center;
  background: #ffffff;
  color: #333333;
  padding: 4px 5px;
  border-radius: 2px;
  display: block;
  font-family: 'IBM Plex Sans', sans-serif !important;
}

.band .Piyasa b {
  font-size: 12px;
  position: relative;
  top: -3px;
}

.band .Piyasa span {
  font-size: 16px;
}

.band .Saat {
  text-align: center;
  font-size: 16px;
  background: #ffffff;
  color: #333333;
  padding: 4px 5px;
  border-radius: 2px;
  display: block;
  font-family: 'IBM Plex Sans', sans-serif !important;
}

.el-carousel__item a {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  margin: 0;
}

.el-carousel__indicators--vertical {
  display: none !important;
}

.haber {
  background: #fff;
  padding: 3px 5px;
  border-radius: 2px;
  -webkit-box-shadow: inset 0px 0px 2px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: inset 0px 0px 2px -1px rgba(0, 0, 0, 0.75);
  box-shadow: inset 0px 0px 2px -1px rgba(0, 0, 0, 0.75);
}

.haber img {
  width: 30px;
  position: relative;
}

.haber .el-carousel {
  width: calc(100% - 40px);
  float: right;
  margin-top: 2px;
}

</style>



// WEBPACK FOOTER //
// src/components/Pack/Panel/PanelBand.vue